import { client } from '@atlassian/rovo-content-bridge-api/client-types';

export const ROVO_CHAT_CLIENT_ID = client('rovo-chat');
